var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuestionLayout',{attrs:{"question":_vm.questionText},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('AnswerList',{attrs:{"gridLayout":true,"answers":_vm.answers},on:{"answer":_vm.onAnswer}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }